import { useCallback, useState, useEffect } from "react";

export const KanbanBoard = ({
  columns,
  bgColors,
  cards,
  onCardMove,
  renderCard,
}) => {
  return (
    <div className="flex h-full w-full gap-4 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 py-5">
      {columns.map((column) => (
        <KanbanColumn
          key={column}
          title={column}
          column={column}
          cards={cards}
          onCardMove={onCardMove}
          renderCard={renderCard}
        />
      ))}
    </div>
  );
};

const KanbanColumn = ({ title, column, cards, onCardMove, renderCard }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    const handleTouchStart = () => setIsTouched(true);
    const handleTouchEnd = () => setIsTouched(false);

    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchend", handleTouchEnd);

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      const cardId = e.dataTransfer.getData("cardId");
      const oldStageId = e.dataTransfer.getData("stageId");
      onCardMove(cardId, column, oldStageId);
    },
    [column, onCardMove]
  );

  const filteredCards = cards.filter((c) => c.column === column);
  let totalAmount = filteredCards.reduce((sum, card) => {
    if (card.type === "manual-quotation") {
      return sum + (card.net_Amount || 0);
    } else if (card.type === "window-quotation") {
      return sum + (card.quote_Amount || 0);
    } else if (card.type === "material-quotation") {
      return sum + (card.net_Amount || 0);
    }
    return sum;
  }, 0);

  return (
    <div
      className="shrink-0 rounded-md flex flex-col
  w-[90%] xsm:w-[80%] sm:w-[60%] md:w-[50%] lg:w-[30%] xl:w-1/5 3xl:w-1/6"
    >
      <div className="flex items-center justify-between text-black rounded p-4 bg-gray h-16">
        <div className="font-semibold flex flex-col">
          {title}
          {totalAmount > 0 && (
            <span className="text-sm text-primary font-bold">
              ₹{totalAmount.toFixed(2)}
            </span>
          )}
        </div>
        <span className="text-sm text-primary font-bold">
          {filteredCards.length}
        </span>
      </div>

      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onTouchStart={() => setIsTouched(true)}
        onTouchEnd={() => setIsTouched(false)}
        className={`transition-colors rounded-md p-2 bg-gray-2 max-h-[calc(100vh-300px)]
          ${filteredCards.length === 0 ? "h-full bg-gray-2" : "bg-gray-2"}
          ${
            isHovered || isTouched
              ? "overflow-y-auto scrollbar-thin"
              : "overflow-hidden"
          }`}
      >
        {filteredCards.length > 0 ? (
          filteredCards.map((card) => (
            <div className="w-full mb-2">{renderCard(card)}</div>
          ))
        ) : (
          <div className="text-gray-500 text-center py-10">
            No Data Available
          </div>
        )}
      </div>
    </div>
  );
};
